import type { CSSProperties } from 'react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

// Sin next-themes (esto es Vite, no Next.js) — el tema ya vive como clase
// `.dark` en <html> vía useTheme.ts, así que Sonner solo necesita leerla una
// vez por render (MutationObserver sería sobreingeniería para un toggle manual).
function Toaster({ ...props }: ToasterProps) {
  const theme = document.documentElement.classList.contains('dark') ? 'dark' : 'light'

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
